import { WorkawareApi } from 'apis/WorkawareApi'
import { InAppNotificationDto, InAppNotificationCreateDto } from 'data/dtos'

export class NotificationService {
  constructor(private api: WorkawareApi) {}

  async getUserNotifications(offset: number = 0, take: number = 20) {
    return this.api.notifications.getUserNotifications(offset, take)
  }

  async getUnreadCount(): Promise<number> {
    return this.api.notifications.getUnreadCount()
  }

  async markAsRead(recipientId: number) {
    return this.api.notifications.markAsRead(recipientId)
  }

  async markAllAsRead() {
    return this.api.notifications.markAllAsRead()
  }

  async delete(notificationId: number) {
    return this.api.notifications.delete(notificationId)
  }

  async send(data: InAppNotificationCreateDto) {
    return this.api.notifications.send(data)
  }
}
